<a class="d-block p-2 {{ Utility.mobile ? 'white-bg' : 'border-bottom' }}" *ngIf="rtwad"
	[routerLink]="disableNavigate ? undefined : [rtwadPath, rtwad.Id]">
	<div *ngIf="['owner', 'admin'].includes(mode)" class="d-flex flex-wrap">
		<div class="badge badge-pill fs-normal" [ngClass]="getStatusClass(rtwad.Status)">
			{{ rtwad.Status | readable: "RtwadStatus" }}
		</div>
	</div>

	<!-- <div class="d-flex flex-wrap justify-content-between f-gray fs-sm">
		<div class="no-wrap-ellipsis" *ngIf="rtwad.RegisterTime">
			ثبت {{rtwad.RegisterTime | pdate:mode!=='admin'}}
		</div>

		<div class="f-gray no-wrap-ellipsis" *ngIf="rtwad.UpdateTime && mode==='admin'">
			بروزرسانی {{rtwad.UpdateTime | pdate:mode!=='admin'}}
		</div>

		<div class="f-gray no-wrap-ellipsis" *ngIf="rtwad.ExpirationTime">
			انقضا {{rtwad.ExpirationTime | pdate:mode!=='admin'}}
		</div>
	</div> -->

	<div class="d-flex align-items-center fs-sm no-wrap-ellipsis" *ngIf="rtwad.IsIndexed && rtwad.Source">
		<img class="icon-sm ml-1" *ngIf="rtwad.Source.Url" [alt]="rtwad.Source.Title"
			[src]="rtwad.Source.Url | favicon" />
		<span class="no-wrap-ellipsis">در {{ rtwad.Source.Title }} </span>&nbsp;
		<span class="f-gray no-wrap-ellipsis">
			<ng-container *ngIf="rtwad.StartTime || rtwad.UpdateTime || rtwad.RegisterTime">({{
				rtwad.StartTime || rtwad.UpdateTime || rtwad.RegisterTime
				| pdate: true
				}})</ng-container>
		</span>
	</div>

	<h3 class="h6 f-blue mb-1">{{ rtwad.Title }}</h3>
	<div class="fs-sm">
		{{ rtwad.IsRemote ? "از" : "در" }}
		{{ Utility.locationString(rtwad.State, rtwad.City) }}
	</div>
	<div class="d-flex gap-1 mb-1">
		<div *ngIf="rtwad.Images?.length">
			<img *ngIf="rtwad.Images[0] as img" [src]="img.startsWith('http') ? img : imagePath + img + '?size=80'"
				class="cover rounded" style="width: 5rem; aspect-ratio: 1/1" />
		</div>

		<div *ngIf="rtwad.Brief" class="flex-grow-1 lh-xs fs-sm" [innerHTML]="rtwad.Brief">
		</div>
	</div>
	<div class="d-flex align-items-center justify-content-between mb-2">
		<button class="btn btn-sm btn-danger btn-red" *ngIf="['owner'].includes(mode) && rtwad.Status != 'Archived'"
			[disabled]="loadingFinish" (click)="ArchiveAd($event)">
			{{ loadingFinish ? "در حال بروزرسانی..." : "پایان آگهی" }}
		</button>
	</div>
	<div class="d-flex {{
			mode == 'default' ? 'w-100 overflow-x-auto scroll-hidden' : 'flex-wrap'
		}}  gap-1 align-items-center">
		<span *ngIf="rtwad.IsPaid" class="badge badge-pill border fs-sm fw-normal p-0">
			<img class="icon-sm" src="/assets/images/icons/vanguard.svg" alt="آگهی پیشتاز" />
			<span class="p-1 pl-2">آگهی پیشتاز</span>
		</span>
		<div *ngFor="let tag of rtwad.Tags" class="badge p-1 x-light-gray-bg fs-sm">
			{{ tag }}
		</div>
	</div>
</a>